import type { TextSeparatorAttributes } from '../../types/cms'
import { MarkdownText } from 'ui-kit'
import { Container, Box } from '@mui/material'
import { TextSeparatorContainer } from './styles'

const TextSeparator = ({
  text,
  containerWidth,
  textColour = '#FFF',
  backgroundColour = '#F5F7FA',
}: TextSeparatorAttributes) => {
  return (
    <TextSeparatorContainer
      backgroundColour={backgroundColour}
      textColour={textColour}
    >
      <Container
        maxWidth="md"
        sx={containerWidth ? { maxWidth: containerWidth } : undefined}
      >
        <Box sx={{ whiteSpace: 'pre-wrap' }}>
          <MarkdownText>{text}</MarkdownText>
        </Box>
      </Container>
    </TextSeparatorContainer>
  )
}

export default TextSeparator
